<template>
  <!--
      作者：kmdshop
      时间：2020-06-01
      描述：插件中心-政府园区-修改
    -->
  <el-dialog
    title="修改政策"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="50%"
  >
    <div class="product-add pb50">
      <el-form
        size="small"
        :model="form"
        ref="form"
        :rules="rules"
        label-width="100px"
      >

        <!-- 通用字段 - 名称 -->
        <el-form-item label="名称" prop="name">
          <el-input
            v-model="form.name"
            placeholder="请输入名称"
            class="max-w460"
          ></el-input>
        </el-form-item>

        <!-- 文件上传 -->
        <el-form-item label="文件" prop="file">
          <div class="file-upload-container">
            <!-- 已上传文件列表 -->
            <div v-if="form.file && form.file.length > 0" class="file-list">
              <div 
                v-for="(file, index) in form.file" 
                :key="index" 
                class="file-item"
              >
                <div class="file-info">
                  <i class="el-icon-document file-icon"></i>
                  <span class="file-name">{{ getFileName(file.file_path) }}</span>
                  <span class="file-size">{{ getFileSize(file) }}</span>
                </div>
                <div class="file-actions">
                  <!-- <el-button 
                    size="mini" 
                    type="text" 
                    @click="previewFile(file.file_path)"
                  >预览</el-button> -->
                  <el-button 
                    size="mini" 
                    type="text" 
                    @click="downloadFile(file.file_path)"
                  >下载</el-button>
                  <el-button 
                    size="mini" 
                    type="text" 
                    class="delete-btn" 
                    @click="deleteFile(index)"
                  >删除</el-button>
                </div>
              </div>
            </div>
            
            <!-- 上传按钮 -->
            <div class="upload-btn-container">
              <el-button 
                type="primary" 
                icon="el-icon-upload" 
                @click="openFileUpload"
                :disabled="form.file && form.file.length >= 1"
              >
                上传文件
              </el-button>
              <div class="upload-tip">
                支持PDF、Word、Excel、PPT等文档格式，单个文件不超过50MB
              </div>
            </div>
          </div>
        </el-form-item>

        <!--提交-->
        <div class="common-button-wrapper">
          <el-button size="small" type="info" @click="cancelFunc"
            >取消</el-button
          >
          <el-button
            size="small"
            type="primary"
            @click="onSubmit"
            :loading="loading"
            >提交</el-button
          >
        </div>
      </el-form>
      
      <!-- 文件上传组件 -->
      <Upload
        v-if="isFileUpload"
        :config="{ 
          total: 1, 
          accept: '.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt',
          maxSize: 50 * 1024 * 1024 // 50MB
        }"
        :isupload="isFileUpload"
        @returnImgs="returnFileFunc"
      >
        上传文件
      </Upload>
    </div>
  </el-dialog>
</template>

<script>
import ParkApi from "@/api/park.js";
import Upload from "@/components/file/Upload";

export default {
  components: {
    /*文件上传*/
    Upload: Upload,
  },
  data() {
    return {
      /*是否上传文件*/
      isFileUpload: false,
      /*form表单数据*/
      form: {
        name: "",
        file: [], // 存储文件信息
        zc_id: null,
        sort: 50,
      },
      loading: false,
      /*验证规则*/
      rules: {
        name: [{ required: true, message: "请输入名称", trigger: "blur" }],
        file: [{ required: true, message: "请上传文件", trigger: "change" }],
      },
      dialogVisible: false,
    };
  },
  created() {
    this.dialogVisible = this.open_add;
    this.getDetail();
  },
  props: ["open_add", "zc_id", 'supply_id'],
  watch: {
    open_add: function(n, o) {
      this.dialogVisible = this.open_add;
      if (this.open_add) {
        this.getDetail();
      }
    }
  },
  methods: {
    /*获取文件名*/
    getFileName(filePath) {
      if (!filePath) return '';
      return filePath.split('/').pop() || filePath;
    },
    
    /*获取文件大小显示*/
    getFileSize(file) {
      if (!file || !file.size) return '';
      const size = file.size;
      if (size < 1024) {
        return size + ' B';
      } else if (size < 1024 * 1024) {
        return (size / 1024).toFixed(2) + ' KB';
      } else {
        return (size / (1024 * 1024)).toFixed(2) + ' MB';
      }
    },
    
    /*预览文件*/
    previewFile(filePath) {
      if (!filePath) return;
      
      // 根据文件类型选择预览方式
      const fileName = this.getFileName(filePath);
      const fileExt = fileName.split('.').pop().toLowerCase();
      
      // PDF文件可以在新窗口打开预览
      if (fileExt === 'pdf') {
        window.open(filePath, '_blank');
      } else {
        // 其他文件类型提示下载
        this.$message.info('该文件类型暂不支持在线预览，请下载后查看');
        this.downloadFile(filePath);
      }
    },
    
    /*下载文件*/
    downloadFile(filePath) {
      if (!filePath) return;
      
      const link = document.createElement('a');
      link.href = filePath;
      link.download = this.getFileName(filePath);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    
    /*打开文件上传*/
    openFileUpload() {
      this.isFileUpload = true;
    },
    
    /*文件上传回调*/
    returnFileFunc(files) {
      if (files && files.length > 0) {
        // 只取第一个文件（因为配置了total:1）
        const file = files[0];
        
        // 验证文件类型
        const allowedTypes = ['.pdf', '.doc', '.docx', '.xls', '.xlsx', '.ppt', '.pptx', '.txt'];
        const fileName = this.getFileName(file.file_path);
        const fileExt = '.' + fileName.split('.').pop().toLowerCase();
        
        if (!allowedTypes.includes(fileExt)) {
          this.$message.error('不支持的文件类型，请上传文档类文件');
          this.isFileUpload = false;
          return;
        }
        
        // 添加到文件列表
        this.$set(this.form, "file", [file]);
        
        // 触发验证
        this.$refs.form.validateField('file');
      }
      
      this.isFileUpload = false;
    },
    
    /*删除文件*/
    deleteFile(index) {
      this.form.file.splice(index, 1);
      // 触发验证
      this.$refs.form.validateField('file');
    },
    
    /*关闭弹窗*/
    dialogFormVisible(result) {
      this.$emit("close", {});
    },
    
    cancelFunc() {
      //取消
      this.dialogFormVisible("error");
    },
    
  getDetail() {
  let self = this;
  ParkApi.detailzc({ zc_id: self.zc_id }, true)
    .then((res) => {
      console.log('详情接口返回:', res.data);
      
      // 直接使用接口返回的数据
      self.form = { ...res.data };
      
      // 确保 file 字段格式正确
      if (res.data.file && Array.isArray(res.data.file)) {
        // 如果接口返回了 file 数组，直接使用
        self.form.file = res.data.file;
      } else if (res.data.file_path) {
        // 如果只有 file_path，转换为 file 数组格式
        self.form.file = [{
          file_id: res.data.file_id,
          file_path: res.data.file_path,
          real_name: res.data.real_name || self.getFileName(res.data.file_path)
        }];
      } else {
        // 没有文件数据
        self.form.file = [];
      }
      
      console.log('处理后的文件数据:', self.form.file);
      self.loading = false;
    })
    .catch((error) => {
      console.error('获取详情失败:', error);
    });
},
    onSubmit() {
      let self = this;
      
      self.$refs.form.validate((valid) => {
        if (valid) {
          self.loading = true;
          
          // 准备提交数据
          const submitData = {
            ...self.form,
            supply_id: self.supply_id,
            zc_id: self.zc_id
          };
          
          // 如果有文件，提取文件路径和ID
          if (self.form.file && self.form.file.length > 0) {
            submitData.file_path = self.form.file[0].file_path;
            submitData.file_id = self.form.file[0].file_id;
          }
          
          ParkApi.editzc(submitData, true)
            .then((data) => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: "success",
              });
              self.dialogFormVisible("success");
            })
            .catch((error) => {
              self.loading = false;
              self.$message.error("提交失败，请重试");
            });
        } else {
          self.$message.error("请完善表单信息");
        }
      });
    },
  },
};
</script>

<style scoped>
.file-upload-container {
  width: 100%;
}

.file-list {
  margin-bottom: 15px;
}

.file-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  margin-bottom: 8px;
  background-color: #fafafa;
}

.file-info {
  display: flex;
  align-items: center;
  flex: 1;
}

.file-icon {
  font-size: 20px;
  color: #409eff;
  margin-right: 10px;
}

.file-name {
  font-size: 14px;
  color: #606266;
  margin-right: 10px;
  max-width: 300px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.file-size {
  font-size: 12px;
  color: #909399;
}

.file-actions {
  display: flex;
  gap: 10px;
}

.delete-btn {
  color: #f56c6c;
}

.upload-btn-container {
  text-align: center;
  padding: 20px;
  border: 2px dashed #dcdfe6;
  border-radius: 4px;
  background-color: #fafafa;
}

.upload-tip {
  margin-top: 10px;
  font-size: 12px;
  color: #909399;
}

.common-button-wrapper {
  text-align: center;
  margin-top: 30px;
  padding-top: 20px;
  border-top: 1px solid #e4e7ed;
}

.max-w460 {
  max-width: 460px;
}

.pb50 {
  padding-bottom: 50px;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .file-item {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .file-actions {
    margin-top: 10px;
    width: 100%;
    justify-content: flex-end;
  }
  
  .file-name {
    max-width: 200px;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/plus/supply/zhengce/part/edit.vue